import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AvailabilityStatusMap, Reserve } from 'app/entity/models/entity';
import { isAuthorizedInKeycloak } from 'app/keycloak/reducers/keycloak.reducer';
import { Subscription } from 'rxjs';
import { CommonState } from 'search/full-card/models/card-header';

@Component({
  selector: 'app-toolbar-buttons-rapido',
  templateUrl: './toolbar-buttons-rapido.component.html',
  styleUrls: ['./toolbar-buttons-rapido.component.scss']
})
export class ToolbarButtonsRapidoComponent implements OnInit, OnDestroy {
  @Input() public instanceId: string;
  @Input() public label: string;
  @Input() public recordId: string[];
  @Input() public isElectronicResource: boolean;
  @Input() public eResourceUrls: string[];
  @Input() public tabName: string;
  @Input() public isbn: string;
  @Input() public hasEcontentIssues: boolean;
  @Input() public availability: AvailabilityStatusMap;
  @Input() public reserve: Reserve;
  @Input() public eVendorAvailabilityPending = false;

  @Input() public type = 'primary';
  @Input() public resourceId: string;
  @Input() public title: string;
  @Input() public getOneEdition = false;
  @Input() public ariaDescribedBy = '';

  public subscriptions = new Subscription();
  public isAuthorised$ = this.store.select(isAuthorizedInKeycloak);
  public isAuthorised: boolean = false;

  constructor(
    private readonly store: Store<CommonState>,
  ) { }

  public ngOnInit() {
    this.isAuthorised$.subscribe(isAuthorised => this.isAuthorised = isAuthorised);
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
